import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Select, } from 'antd';
import AddDrawer from '../../component/AddDrawer';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';

import { editRelationType, getRelationType } from '../../feature/relation/RelationTypeSlice';
import { categoryTypes } from '../../constant/Constatnt';
import { editCategory, getCategory } from '../../feature/category/CategorySlice';



function EditCategory({ editData }) {
    const { categoryType, categoryName, _id } = editData
    const { actionLoader } = useSelector((state) => state.categories);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()
    console.log("editData cat", editData)

    useEffect(() => {
        form.setFieldsValue({
            categoryType, categoryName,
        })
    }, [open])

    const onFinish = async (values) => {

        const resultAction = await dispatch(editCategory({ ...values, categoryId: _id }));
        if (editCategory.fulfilled.match(resultAction)) {
            await dispatch(getCategory({ types: categoryTypes[0] }));
            form.resetFields();
            setOpen(false);
        } else {
            console.error("edit category");
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const AddForm = (
        <Form
            layout="vertical"
            form={form}
            name="add-service-form"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                name="categoryType"
                label="Select  Type"
                rules={[{ required: true, message: 'Please select category type ' }]}
            >
                <Select placeholder="Select  Category Type">
                    {categoryTypes.map((opt) => (
                        <Select.Option value={opt} key={opt}>{opt}</Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                name="categoryName"
                label="Category Name"
                rules={[{ required: true, message: 'Please enter  category name ' }]}
            >
                <Input placeholder='Enter Category Name' />
            </Form.Item>

            <Form.Item  >

                <div className='submit_btn'>
                    <Space>
                        <Button type="primary" loading={actionLoader} htmlType="submit">
                            Submit
                        </Button>
                        <Button danger htmlType="button" onClick={handleCancel}>
                            Reset
                        </Button>
                    </Space>
                </div>
            </Form.Item>
        </Form >


    );

    const editProps = {
        open,
        setOpen,
        title: 'Edit  Category',
        action: 'Edit',
        content: AddForm,
        btnType: "link"

    };

    return (
        <section>
            <AddDrawer {...editProps} />
        </section>
    );
}


export default EditCategory